import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import TextPanels from './components/TextPanels/TextPanels';
import TextPanelManagementEditor from './components/TextPanelEditor/TextPanelManagementEditor';

const INITIAL_TEXT_PANEL = { id: null, isEdit: false };

const TextPanelsSettings = ({ companyId }) => {
  const [textPanelToEdit, setTextPanelToEdit] = useState(INITIAL_TEXT_PANEL);
  const history = useHistory();
  const { state, search } = useLocation();

  const handleOpenEditor = useCallback(
    id => {
      history.push({ pathname: `/eg/company-settings`, state: { ...state, textPanelId: id }, search });
    },
    [state, search]
  );

  const handleCloseEditor = useCallback(() => {
    history.goBack();
  }, []);

  useEffect(() => {
    if (state.option && state?.textPanelId) {
      setTextPanelToEdit({ id: state.textPanelId, isEdit: true });
    } else {
      setTextPanelToEdit(INITIAL_TEXT_PANEL);
    }
  }, [state]);

  return (
    <>
      {textPanelToEdit.isEdit ? (
        <TextPanelManagementEditor textPanelId={textPanelToEdit.id} onClose={handleCloseEditor} companyId={companyId} />
      ) : (
        <TextPanels handleOpenEditor={handleOpenEditor} companyId={companyId} />
      )}
    </>
  );
};

export default TextPanelsSettings;
